// Shared helper functions for Jobs screens

/**
 * Generate a background color based on name string
 * @param {string} name - The name to generate color from
 * @returns {string} Hex color code
 */
export const getColorFromName = (name) => {
  const colors = ['#fce7f3', '#dbeafe', '#dcfce7', '#fef3c7', '#f3e8ff', '#fef2f2', '#ecfeff'];
  return colors[name ? name.charCodeAt(0) % colors.length : 0];
};

/**
 * Generate a text color based on name string
 * @param {string} name - The name to generate color from
 * @returns {string} Hex color code
 */
export const getTextColorFromName = (name) => {
  const colors = ['#db2777', '#2563eb', '#16a34a', '#d97706', '#9333ea', '#dc2626', '#0891b2'];
  return colors[name ? name.charCodeAt(0) % colors.length : 0];
};

/**
 * Get background color for job type badge
 * @param {string} type - The job type string
 * @returns {string} Hex color code
 */
export const getJobTypeBgColor = (type) => {
  const typeStr = (type || '').toLowerCase();
  if (typeStr.includes('locum')) return '#fce7f3';
  if (typeStr.includes('full')) return '#dbeafe';
  if (typeStr.includes('contract')) return '#fef3c7';
  return '#f3f4f6';
};

/**
 * Get text color for job type badge
 * @param {string} type - The job type string
 * @returns {string} Hex color code
 */
export const getJobTypeColor = (type) => {
  const typeStr = (type || '').toLowerCase();
  if (typeStr.includes('locum')) return '#db2777';
  if (typeStr.includes('full')) return '#2563eb';
  if (typeStr.includes('contract')) return '#d97706';
  return '#4b5563';
};

/**
 * Helper to get the parent profession type code
 * - 'a-a-1' -> 'a' (Doctor specialties)
 * - 'e-x-1' -> 'e-x' (Medical Assistant, etc.)
 * @param {string} code - The profession type code
 * @returns {string|null} Parent type code
 */
export const getParentTypeCode = (code) => {
  if (!code) return null;
  const parts = code.split('-');
  if (parts.length >= 2 && parts[1] === 'x') {
    return `${parts[0]}-x`; // e-x, f-x, etc.
  }
  return parts[0]; // a, b, c, d
};

/**
 * Helper to calculate dates for quick range selection
 * @param {string} range - The quick range value ('today', 'tomorrow', 'thisWeek', 'nextWeek')
 * @returns {{from: string, to: string}} Date strings in YYYY-MM-DD format
 */
export const getQuickRangeDates = (range) => {
  const today = new Date();
  let fromDate = new Date();
  let toDate = new Date();

  switch (range) {
    case 'today':
      break;
    case 'tomorrow':
      fromDate.setDate(today.getDate() + 1);
      toDate.setDate(today.getDate() + 1);
      break;
    case 'thisWeek': {
      const daysUntilSunday = 7 - today.getDay();
      toDate.setDate(today.getDate() + daysUntilSunday);
      break;
    }
    case 'nextWeek': {
      const dayOfWeek = today.getDay();
      const daysUntilNextMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek;
      fromDate.setDate(today.getDate() + daysUntilNextMonday);
      toDate = new Date(fromDate);
      toDate.setDate(fromDate.getDate() + 6);
      break;
    }
    default:
      break;
  }

  return {
    from: fromDate.toISOString().split('T')[0],
    to: toDate.toISOString().split('T')[0],
  };
};
